// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__FAav_","name":"Header_name__1hJYH","birthday":"Header_birthday__3TARF","skeleton":"Header_skeleton__1OHa2"};